import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { QuestionService } from 'app/question/services/question.service';
import { QuestionBankListModel } from 'app/question/models/question-bank-list.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-question-bank-list',
    templateUrl: './question-bank-list.component.html',
    styleUrls: ['./question-bank-list.component.css']
})
export class QuestionBankListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    questionBanks: QuestionBankListModel[];
    questionBankList: QuestionBankListModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;

    constructor(
        private questionService: QuestionService,
        private fb: FormBuilder,
        private sortService: SortService
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Question Banks' }

        this.questionService.getAllQuestionBank().subscribe(
            questionBanks => {
                this.questionBanks = questionBanks;
                this.questionBankList = questionBanks;
            },
            error => this.errors = error.errorList
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.questionBankList = this.sortService.filterAndSortlist(this.questionBanks, newValue, this.lastSort);
        });
    }
}
